import { cloneDeep } from "lodash-es";
import { useAddPositionToStep } from "@/flow/application/useAddPositionToStep";

export function getOutputListForAllStep(
  stepList: Array<any>,
  options: { useStableIndex?: boolean; skipPositioning?: boolean } = {}
): Array<any> {
  const { useStableIndex = false, skipPositioning = false } = options;
  const resolveIndex = (step: any) => {
    if (typeof step?.stepNumber === "number" && step.stepNumber > 0) {
      return useStableIndex ? step.stepNumber : step.stepNumber - 1;
    }

    return step?.stepPosition?.x;
  };
  const newSteps = skipPositioning
    ? stepList
    : useAddPositionToStep(cloneDeep(stepList));
  const outputList = [];
  function getList(list) {
    list.forEach((step, index) => {
      step.ix = index;
      if (step.output) {
        const values: any = Object.values(step?.actions || []);
        outputList.push({
          ...step,
          output: step?.output,
          ix: step?.ix,
          stepNumber: step?.stepNumber,
          index: resolveIndex(step),
          connection: step.name,
          action: values ? values?.[0]?.description : "",
          stepPosition: step?.stepPosition,
          conditionPosition: step?.conditionPosition,
        });
      }

      if (step.steps) {
        getList(step.steps);
      }
      if (step.routes) {
        getList(step.routes);
      }
    });
  }

  getList(newSteps);

  return outputList;
}
